export const ORDER_METHOD_WHATSAPP = 1;
export const ORDER_METHOD_ONLINE = 2;

export const PAYMENT_CHANNEL_NAMES = {
    1: 'PayU',
    2: 'Mercado Pago',
    3: 'Wompi',
    4: 'Paypal',
    5: 'Stripe',
    6: 'Pago Manual',
};

export const PAYMENT_STATUS_BY_NORMALIZED_ID = {
    1: 'Pendiente de pago',
    2: 'En espera',
    3: 'Rechazado / cancelado',
    4: 'Pagado',
};

export function getOrderMethodId(order) {
    return Number(order?.order_method_id ?? order?.order_method?.id ?? 0);
}

export function isOnlinePaymentOrder(order) {
    return getOrderMethodId(order) === ORDER_METHOD_ONLINE;
}

export function getPaymentChannelName(order) {
    const fromRelation = order?.payment_channel?.name || order?.order_payment?.payment_channel?.name;
    if (fromRelation) return fromRelation;

    const channelId = Number(
        order?.payment_channel_id ?? order?.order_payment?.payment_channel_id ?? 0
    );
    return PAYMENT_CHANNEL_NAMES[channelId] || null;
}

export function getOrderOrigin(order) {
    const branchName = order?.user_store?.name || null;
    const branchId = order?.user_store?.id || null;
    const gateway = getPaymentChannelName(order);

    if (isOnlinePaymentOrder(order)) {
        return {
            isGateway: true,
            channelLabel: 'Pasarela de pagos',
            primaryLabel: gateway || 'Pago en línea',
            branchName,
            branchId,
        };
    }

    return {
        isGateway: false,
        channelLabel: 'WhatsApp',
        primaryLabel: branchName || 'Sucursal',
        branchName,
        branchId,
    };
}

export function getNormalizedPaymentStatusLabel(info) {
    const normalized = Number(info?.transaction_status_normalized);
    if (PAYMENT_STATUS_BY_NORMALIZED_ID[normalized]) {
        return PAYMENT_STATUS_BY_NORMALIZED_ID[normalized];
    }
    if (info?.transaction_status) return info.transaction_status;
    return null;
}
